import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import SupplyChainCommandCenter from '../components/SupplyChainCommandCenter/SupplyChainCommandCenter';

const SupplyChainCommandCenterPage: React.FC = () => {
  const navigate = useNavigate();

  const handleCaseSelect = (caseId: string) => {
    navigate(`/exceptions?domain=supply_chain&caseId=${encodeURIComponent(caseId)}`);
  };

  const handleBackToDomains = () => {
    navigate('/domains');
  };

  return (
    <div style={{ width: '100%', minHeight: '100vh', backgroundColor: '#fafafa' }}>
      {/* Simple header with back button */}
      <div style={{
        padding: '16px 24px',
        backgroundColor: 'white',
        borderBottom: '1px solid #e1dfdd',
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
      }}>
        <Button
          appearance="subtle"
          icon={<ArrowLeftRegular />}
          onClick={handleBackToDomains}
        >
          Back to Workflows
        </Button>
        <div style={{
          fontSize: '20px',
          fontWeight: 600,
          color: '#242424'
        }}>
          Supply Chain Command Center
        </div>
      </div>

      {/* Command Center content */}
      <SupplyChainCommandCenter onCaseSelect={handleCaseSelect} />
    </div>
  );
};

export default SupplyChainCommandCenterPage;
